import { OnboardingContract } from '../Interfaces/onboarding.interface';
import { CompanyData } from '../Interfaces/company-data.interface';
import { PlanData } from '../Interfaces/plan-data.interface';
import { OnboarderData } from '../Interfaces/onboarder-data.interface';
import { OnboardingStatus, onboardingStatusRank } from '../Enums/onboarding-status.enum';

export class Onboarding {
  id!: string;
  status!: OnboardingStatus;
  organization_exists!: boolean;
  company_data!: CompanyData | null;
  onboarder_data!: OnboarderData | null;
  plan_data!: PlanData | null;
  admin_consent_granted_at!: string | null;
  custom_offer_id!: string | null;

  constructor(data: Partial<OnboardingContract>) {
    Object.assign(this, data);
  }

  hasConsent(): boolean {
    return !!this.admin_consent_granted_at;
  }

  hasCustomOffer(): boolean {
    return !!this.custom_offer_id;
  }

  hasSelectedPlan(): boolean {
    return !!this.plan_data;
  }

  isStatusAtLeast(status: OnboardingStatus): boolean {
    return onboardingStatusRank(this.status) >= onboardingStatusRank(status);
  }
}
